



































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { ActionNames } from '@/constants/ActionNames';

@Component({
  components: {
    Loading,
  },
})
export default class Modal extends Vue {
  public license: string = '';

  public loading: boolean = false;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public async addLicense() {
    this.loading = true;

    if (!this.license) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Vul een nummerplaat in',
      };

      this.loading = false;

      return;
    }

    const success = await this.$store.dispatch(ActionNames.ADD_LICENSE, this.license);

    if (success) {
      this.error = {
        show: true,
        type: 'success',
        message: `Nummerplaat ${this.license} is succesvol toegevoegd aan je nummerplaten`,
      };
    } else {
      this.error = {
        show: true,
        type: 'warning',
        message: `Er ging iets mis tijdens het toevoegen van het nummerplaat ${this.license}`,
      };
    }

    this.loading = false;
  }
}
